//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useRef } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, Grid } from '@material-ui/core';
import SimpleBar from 'simplebar-react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
// import { AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { BASE_URL } from '../../common/constants';
//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';
// import AfitdTypography from '../../common/elemental/AfitdTypography';
import EmployerInviteItem from './EmployerInviteItem';
import AfitdPagination from '../../common/elemental/AfitdPagination';
//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';
import _map from 'lodash/map';
import _slice from 'lodash/slice';
import AfitdButton from '../../common/elemental/AfitdButton';
import { useHistory, useParams } from 'react-router';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: { justifyContent: 'center', marginTop: 15 },
    saveButtonContainer: {
        padding: '15px',
        marginTop: 20,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: { flexDirection: 'column', marginTop: 0 },
    },
    rootContent1: { textAlign: 'center', paddingBottom: '30px' },
    headerText: { marginBottom: 19, fontWeight: 'bold', fontSize: 26 },
    rootContent2: { height: '100%', maxHeight: 450 },
    paginationContainer: {
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: { width: '100%', padding: 15 },
    },
    saveButton: { [theme.breakpoints.down('sm')]: { width: '100%' } },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        // props,
    } = params;

    const defns = {
        root: { container: true },
        rootContent1: { item: true, xl: 7, lg: 8, md: 9, sm: 11, xs: 11 },
        rootContent2: { item: true, xl: 7, lg: 8, md: 9, sm: 11, xs: 11 },
        title: { variant: 'h5', clsSkinnyBold: true /* clsLightBold: true */ },
        message: { variant: 'body1' },
        saveButton: { color: 'primary', label: 'Save' },
        headerText: { variant: 'h5' },
        linkageText: { variant: 'body1' },
        nullSection: { width: '100%' },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const employerInviteList = [
    {
        companyProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FQy1vHVKQQEWLFx8gV8uU%2FprofilePicture%2F20210721020427_1626847467806?alt=media&token=e862081b-3101-466d-9d4a-ae937a4bb34d',
        companyName: 'TEMP Company One',
        inviterProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/users%2FXKcfEowcreeB4obbL0tNqFwIQv62%2FprofilePicture%2F20210928210802_1632877682765?alt=media&token=f1b57097-0ff7-482a-8420-ccc999ba758c',
        inviterName: 'John Smith',
    },
    {
        companyProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FQy1vHVKQQEWLFx8gV8uU%2FprofilePicture%2F20210807212916_1628386156230?alt=media&token=c5822261-4e08-4931-9995-7650dbac8711',
        companyName: 'TEMP Company Two with Looooooong Name',
        inviterProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FsDIWzIHEyNB1ZCyHUU0d%2Fmembers%2Ft5gXf4uAoXZzaG44qi6W7PRWMWv2%2FprofilePicture%2F20211114132717_1636914437372?alt=media&token=41d2a0e5-956c-48cc-8b19-a0f0b46559a9',
        inviterName: 'Peter Pan',
    },
    {
        companyProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FQy1vHVKQQEWLFx8gV8uU%2FprofilePicture%2F20210726212517_1627316717297?alt=media&token=147a3308-df62-4d40-af49-8ccd237d1160',
        companyName: 'TEMP Company Three',
        inviterProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FXB4wg0QMZZUDbGwOAffO%2Fmembers%2FVPD3wLfFg5XKtBkXBa0XcXXuNQs1%2FprofilePicture%2F20211115104420_1636991060775?alt=media&token=965dbe9d-487b-49f9-ae7e-32be968aa4bd',
        inviterName: 'Mary Smith',
    },
    // { companyProfilePicUrl: '', companyName: '', inviterProfilePicUrl: '', inviterName: '' },
    {
        companyProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FQy1vHVKQQEWLFx8gV8uU%2FprofilePicture%2F20210721020427_1626847467806?alt=media&token=e862081b-3101-466d-9d4a-ae937a4bb34d',
        companyName: 'TEMP Company One',
        inviterProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/users%2FXKcfEowcreeB4obbL0tNqFwIQv62%2FprofilePicture%2F20210928210802_1632877682765?alt=media&token=f1b57097-0ff7-482a-8420-ccc999ba758c',
        inviterName: 'John Smith',
    },
    {
        companyProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FQy1vHVKQQEWLFx8gV8uU%2FprofilePicture%2F20210807212916_1628386156230?alt=media&token=c5822261-4e08-4931-9995-7650dbac8711',
        companyName: 'TEMP Company Two with Looooooong Name',
        inviterProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FsDIWzIHEyNB1ZCyHUU0d%2Fmembers%2Ft5gXf4uAoXZzaG44qi6W7PRWMWv2%2FprofilePicture%2F20211114132717_1636914437372?alt=media&token=41d2a0e5-956c-48cc-8b19-a0f0b46559a9',
        inviterName: 'Peter Pan',
    },
    {
        companyProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FQy1vHVKQQEWLFx8gV8uU%2FprofilePicture%2F20210726212517_1627316717297?alt=media&token=147a3308-df62-4d40-af49-8ccd237d1160',
        companyName: 'TEMP Company Three',
        inviterProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FXB4wg0QMZZUDbGwOAffO%2Fmembers%2FVPD3wLfFg5XKtBkXBa0XcXXuNQs1%2FprofilePicture%2F20211115104420_1636991060775?alt=media&token=965dbe9d-487b-49f9-ae7e-32be968aa4bd',
        inviterName: 'Mary Smith',
    },
    {
        companyProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FQy1vHVKQQEWLFx8gV8uU%2FprofilePicture%2F20210721020427_1626847467806?alt=media&token=e862081b-3101-466d-9d4a-ae937a4bb34d',
        companyName: 'TEMP Company One',
        inviterProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/users%2FXKcfEowcreeB4obbL0tNqFwIQv62%2FprofilePicture%2F20210928210802_1632877682765?alt=media&token=f1b57097-0ff7-482a-8420-ccc999ba758c',
        inviterName: 'John Smith',
    },
    {
        companyProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FQy1vHVKQQEWLFx8gV8uU%2FprofilePicture%2F20210807212916_1628386156230?alt=media&token=c5822261-4e08-4931-9995-7650dbac8711',
        companyName: 'TEMP Company Two with Looooooong Name',
        inviterProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FsDIWzIHEyNB1ZCyHUU0d%2Fmembers%2Ft5gXf4uAoXZzaG44qi6W7PRWMWv2%2FprofilePicture%2F20211114132717_1636914437372?alt=media&token=41d2a0e5-956c-48cc-8b19-a0f0b46559a9',
        inviterName: 'Peter Pan',
    },
    {
        companyProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FQy1vHVKQQEWLFx8gV8uU%2FprofilePicture%2F20210726212517_1627316717297?alt=media&token=147a3308-df62-4d40-af49-8ccd237d1160',
        companyName: 'TEMP Company Three',
        inviterProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FXB4wg0QMZZUDbGwOAffO%2Fmembers%2FVPD3wLfFg5XKtBkXBa0XcXXuNQs1%2FprofilePicture%2F20211115104420_1636991060775?alt=media&token=965dbe9d-487b-49f9-ae7e-32be968aa4bd',
        inviterName: 'Mary Smith',
    },
    {
        companyProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FQy1vHVKQQEWLFx8gV8uU%2FprofilePicture%2F20210721020427_1626847467806?alt=media&token=e862081b-3101-466d-9d4a-ae937a4bb34d',
        companyName: 'TEMP Company One',
        inviterProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/users%2FXKcfEowcreeB4obbL0tNqFwIQv62%2FprofilePicture%2F20210928210802_1632877682765?alt=media&token=f1b57097-0ff7-482a-8420-ccc999ba758c',
        inviterName: 'John Smith',
    },
    {
        companyProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FQy1vHVKQQEWLFx8gV8uU%2FprofilePicture%2F20210807212916_1628386156230?alt=media&token=c5822261-4e08-4931-9995-7650dbac8711',
        companyName: 'TEMP Company Two with Looooooong Name',
        inviterProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FsDIWzIHEyNB1ZCyHUU0d%2Fmembers%2Ft5gXf4uAoXZzaG44qi6W7PRWMWv2%2FprofilePicture%2F20211114132717_1636914437372?alt=media&token=41d2a0e5-956c-48cc-8b19-a0f0b46559a9',
        inviterName: 'Peter Pan',
    },
    {
        companyProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FQy1vHVKQQEWLFx8gV8uU%2FprofilePicture%2F20210726212517_1627316717297?alt=media&token=147a3308-df62-4d40-af49-8ccd237d1160',
        companyName: 'TEMP Company Three',
        inviterProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FXB4wg0QMZZUDbGwOAffO%2Fmembers%2FVPD3wLfFg5XKtBkXBa0XcXXuNQs1%2FprofilePicture%2F20211115104420_1636991060775?alt=media&token=965dbe9d-487b-49f9-ae7e-32be968aa4bd',
        inviterName: 'Mary Smith',
    },
    {
        companyProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FQy1vHVKQQEWLFx8gV8uU%2FprofilePicture%2F20210721020427_1626847467806?alt=media&token=e862081b-3101-466d-9d4a-ae937a4bb34d',
        companyName: 'TEMP Company One',
        inviterProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/users%2FXKcfEowcreeB4obbL0tNqFwIQv62%2FprofilePicture%2F20210928210802_1632877682765?alt=media&token=f1b57097-0ff7-482a-8420-ccc999ba758c',
        inviterName: 'John Smith',
    },
    {
        companyProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FQy1vHVKQQEWLFx8gV8uU%2FprofilePicture%2F20210807212916_1628386156230?alt=media&token=c5822261-4e08-4931-9995-7650dbac8711',
        companyName: 'TEMP Company Two with Looooooong Name',
        inviterProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FsDIWzIHEyNB1ZCyHUU0d%2Fmembers%2Ft5gXf4uAoXZzaG44qi6W7PRWMWv2%2FprofilePicture%2F20211114132717_1636914437372?alt=media&token=41d2a0e5-956c-48cc-8b19-a0f0b46559a9',
        inviterName: 'Peter Pan',
    },
    {
        companyProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FQy1vHVKQQEWLFx8gV8uU%2FprofilePicture%2F20210726212517_1627316717297?alt=media&token=147a3308-df62-4d40-af49-8ccd237d1160',
        companyName: 'TEMP Company Three',
        inviterProfilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/employers%2FXB4wg0QMZZUDbGwOAffO%2Fmembers%2FVPD3wLfFg5XKtBkXBa0XcXXuNQs1%2FprofilePicture%2F20211115104420_1636991060775?alt=media&token=965dbe9d-487b-49f9-ae7e-32be968aa4bd',
        inviterName: 'Mary Smith',
    },
];

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const EmployerAccountLinkage = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    // const appContext = useContext(AppContext);
    // const context = useContext(LayoutContext);
    const theme = useTheme();
    const smMatches = useMediaQuery(theme.breakpoints.down('sm'));

    const history = useHistory();
    const myRef = useRef(null);
    let { pageNumber = 1, subPageId } = useParams();
    pageNumber = parseInt(pageNumber);

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [page, setPage] = React.useState(pageNumber);

    //---------------------------------------------------------------------
    // pagination section
    //---------------------------------------------------------------------
    const paginationNumber = Math.ceil(employerInviteList.length / 10);

    const handlePageChange = (event, value) => {
        setPage(value);
        history.push(`${BASE_URL}/tempAuthHandler/${subPageId}/${value}`);
    };
    const start = page * 5 - 5;
    const end = page * 5;
    const employerInviteListSliced = _slice(employerInviteList, start, end);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Grid {...defns.root}>
            <Grid {...defns.rootContent1}>
                <AfitdTypography {...defns.headerText}>Employer Account Linkage</AfitdTypography>
                <AfitdTypography {...defns.linkageText}>You have been invited to join the following employer account(s) below:</AfitdTypography>
            </Grid>
            <Grid {...defns.rootContent2}>
                <SimpleBar style={{ height: '100%', width: '100%' }}>
                    <div ref={myRef} />
                    {_map(employerInviteListSliced, employerInviteItem => (
                        <EmployerInviteItem data={employerInviteItem} />
                    ))}
                </SimpleBar>
                <div {...defns.saveButtonContainer}>
                    {smMatches ? null : <div {...defns.nullSection}> </div>}
                    <div
                        {...defns.paginationContainer}
                        onClick={() => {
                            setTimeout(() => {
                                myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }, 100);
                        }}
                    >
                        <AfitdPagination count={paginationNumber} color="secondary" page={page} onChange={handlePageChange} />
                    </div>
                    <AfitdButton {...defns.saveButton} />
                </div>
            </Grid>
        </Grid>
    );
};

export default EmployerAccountLinkage;
